import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzRating from '~/components/_next/atoms/AzRating.vue';
import RecipesWishlistButtonGraphQL from '~/components/RecipeWishlist/RecipesWishlistButtonGraphQL.vue';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default {
  __name: 'RecipeCardGraphQL',
  props: {
    recipe: {
      type: Object,
      required: true
    },
    imageLoading: {
      type: String,
      required: false,
      default: 'lazy'
    },
    rating: {
      type: Object,
      default: function _default() {}
    },
    isTargetBlank: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var _props$rating, _props$recipe, _props$recipe$fields, _props$rating2, _props$recipe2, _props$recipe2$fields, _props$recipe3, _props$recipe3$carous, _props$recipe3$carous2, _props$recipe4, _props$recipe4$fields, _props$recipe4$fields2, _props$recipe4$fields3, _props$recipe4$fields4, _props$recipe5, _props$recipe6, _props$recipe6$fields, _props$recipe0, _props$recipe1, _props$recipe1$fields;
    var props = __props;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var route = useRoute();
    var recipeBaseLink = 'legacy-Recipe-slug';
    var numberOfReviews = ((_props$rating = props.rating) === null || _props$rating === void 0 ? void 0 : _props$rating.count) || (props === null || props === void 0 ? void 0 : (_props$recipe = props.recipe) === null || _props$recipe === void 0 ? void 0 : (_props$recipe$fields = _props$recipe.fields) === null || _props$recipe$fields === void 0 ? void 0 : _props$recipe$fields.count);
    var averageRating = ((_props$rating2 = props.rating) === null || _props$rating2 === void 0 ? void 0 : _props$rating2.averageRate) || (props === null || props === void 0 ? void 0 : (_props$recipe2 = props.recipe) === null || _props$recipe2 === void 0 ? void 0 : (_props$recipe2$fields = _props$recipe2.fields) === null || _props$recipe2$fields === void 0 ? void 0 : _props$recipe2$fields.averageRate);
    var recipeImage = ((_props$recipe3 = props.recipe) === null || _props$recipe3 === void 0 ? void 0 : (_props$recipe3$carous = _props$recipe3.carouselCollection) === null || _props$recipe3$carous === void 0 ? void 0 : (_props$recipe3$carous2 = _props$recipe3$carous.items[0]) === null || _props$recipe3$carous2 === void 0 ? void 0 : _props$recipe3$carous2.url) || (props === null || props === void 0 ? void 0 : (_props$recipe4 = props.recipe) === null || _props$recipe4 === void 0 ? void 0 : (_props$recipe4$fields = _props$recipe4.fields) === null || _props$recipe4$fields === void 0 ? void 0 : (_props$recipe4$fields2 = _props$recipe4$fields.carousel[0]) === null || _props$recipe4$fields2 === void 0 ? void 0 : (_props$recipe4$fields3 = _props$recipe4$fields2.fields) === null || _props$recipe4$fields3 === void 0 ? void 0 : (_props$recipe4$fields4 = _props$recipe4$fields3.file) === null || _props$recipe4$fields4 === void 0 ? void 0 : _props$recipe4$fields4.url);
    var recipeTitle = (props === null || props === void 0 ? void 0 : (_props$recipe5 = props.recipe) === null || _props$recipe5 === void 0 ? void 0 : _props$recipe5.title) || (props === null || props === void 0 ? void 0 : (_props$recipe6 = props.recipe) === null || _props$recipe6 === void 0 ? void 0 : (_props$recipe6$fields = _props$recipe6.fields) === null || _props$recipe6$fields === void 0 ? void 0 : _props$recipe6$fields.title);
    var recipeAttribute = function recipeAttribute() {
      var _props$recipe7, _props$recipe7$fields, _props$recipe8, _props$recipe$cosmect, _props$recipe9, _props$recipe9$cosmec, _props$recipe9$cosmec2;
      var category = props === null || props === void 0 ? void 0 : (_props$recipe7 = props.recipe) === null || _props$recipe7 === void 0 ? void 0 : (_props$recipe7$fields = _props$recipe7.fields) === null || _props$recipe7$fields === void 0 ? void 0 : _props$recipe7$fields.category;
      if (category) {
        return category;
      }
      var parentFamily = '';
      switch ((_props$recipe8 = props.recipe) === null || _props$recipe8 === void 0 ? void 0 : _props$recipe8.__typename) {
        case 'PageRecipe':
          parentFamily = (_props$recipe$cosmect = (_props$recipe9 = props.recipe) === null || _props$recipe9 === void 0 ? void 0 : (_props$recipe9$cosmec = _props$recipe9.cosmecticRecipeFamilyCollection) === null || _props$recipe9$cosmec === void 0 ? void 0 : (_props$recipe9$cosmec2 = _props$recipe9$cosmec.items[0]) === null || _props$recipe9$cosmec2 === void 0 ? void 0 : _props$recipe9$cosmec2.parentFamily) !== null && _props$recipe$cosmect !== void 0 ? _props$recipe$cosmect : '';
          break;
      }
      var translationKey = parentFamily.toLowerCase().replace(/\s+/g, '');
      var translatedText = translate("rdp.recipeFamily.".concat(translationKey));
      if (translatedText === "rdp.recipeFamily.".concat(translationKey)) translatedText = '';
      return translatedText || parentFamily;
    };
    var recipeLink = app.localePath({
      name: recipeBaseLink,
      params: {
        slug: (props === null || props === void 0 ? void 0 : (_props$recipe0 = props.recipe) === null || _props$recipe0 === void 0 ? void 0 : _props$recipe0.slug) || (props === null || props === void 0 ? void 0 : (_props$recipe1 = props.recipe) === null || _props$recipe1 === void 0 ? void 0 : (_props$recipe1$fields = _props$recipe1.fields) === null || _props$recipe1$fields === void 0 ? void 0 : _props$recipe1$fields.slug)
      }
    });
    var pageUrl = route.fullPath;
    function sendToGTM(title) {
      var eventData = {
        event: 'generic_event',
        event_category: 'engagement',
        event_action: 'click',
        event_label: 'recipe',
        event_name: 'generic_event',
        recipe: title,
        page_url: pageUrl
      };
      $trackers.gtm.pushEvent('recipe', eventData);
    }
    return {
      __sfc: true,
      props: props,
      translate: translate,
      app: app,
      $trackers: $trackers,
      route: route,
      recipeBaseLink: recipeBaseLink,
      numberOfReviews: numberOfReviews,
      averageRating: averageRating,
      recipeImage: recipeImage,
      recipeTitle: recipeTitle,
      recipeAttribute: recipeAttribute,
      recipeLink: recipeLink,
      pageUrl: pageUrl,
      sendToGTM: sendToGTM,
      AzImg: AzImg,
      AzRating: AzRating,
      RecipesWishlistButtonGraphQL: RecipesWishlistButtonGraphQL,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
};